import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Docs } from './pages/Docs';
import { SignIn } from './pages/SignIn';
import { Dashboard } from './pages/Dashboard';
import { RequireAuth } from './auth/RequireAuth';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignIn mode="signup" />} />
        <Route path="/callback" element={<SignIn />} />
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}